import { Injectable } from "@angular/core";
import { formatDate } from "@angular/common";
import { ClientService } from "../../api/services/client.service";
import { DateTime } from "luxon";
import { ReportService } from "../../api/services/report.service";
import { ReportControllerGetWordSummary$Params } from "../../api/fn/report/report-controller-get-word-summary";

@Injectable({ providedIn: "root" })
export class DownloadService {
  constructor(
    private clientService: ClientService,
    private reportService: ReportService
  ) {}

  downloadKlientenbericht(
    id: number,
    firstName: string,
    lastName: string,
    { range }: { range: { from: Date; to: Date } }
  ) {
    const from = DateTime.fromJSDate(range.from).toISO();
    const to = DateTime.fromJSDate(range.to).toISO();
    this.clientService.clientControllerGetWord({ id, from, to }).subscribe((res) => {
      if (res.size === 4) {
        return false;
      }

      this.handleDownloadedFile(
        res,
        `Klientenbericht_${lastName}-${firstName}_${formatDate(Date.now(), "MM-dd-yyyy", "de-AT")}.docx`
      );
    });
  }

  downloadWordSummary(filter: ReportControllerGetWordSummary$Params) {
    return this.reportService
      .reportControllerGetWordSummary({ ...filter, limit: Number.MAX_SAFE_INTEGER, page: 0 })
      .subscribe((res) => {
        if (res.size === 4) {
          return false;
        }

        let title = "Zusammenfassung_";
        if (filter.createdDateFrom && filter.createdDateTo) {
          title += `${formatDate(filter.createdDateFrom, "MM-dd-yyyy", "de-AT")}-${formatDate(filter.createdDateTo, "MM-dd-yyyy", "de-AT")}_`;
        }
        if (filter.subject) {
          title += `${filter.subject}_`;
        }

        this.handleDownloadedFile(res, `${title}${formatDate(Date.now(), "MM-dd-yyyy", "de-AT")}.docx`);
      });
  }

  handleDownloadedFile(file: Blob, filename: string) {
    const downloadAnchor = document.createElement("a");
    downloadAnchor.style.display = "none";

    downloadAnchor.href = URL.createObjectURL(file);
    downloadAnchor.download = filename;
    downloadAnchor.click();
  }
}
